import MessageLibraryItemModel from 'cio/models/message-library-item';

export default class MessageItem extends MessageLibraryItemModel {}
